<ng-container *ngIf="permConfig.isEditAllowed">
    <div class="container-fluid">
        <app-page-title title="Edit Vendor"></app-page-title>
        <form [formGroup]="vendorForm" (ngSubmit)="updateVendor();" (keydown.enter)="useEnterKey ? $event.preventDefault() : updateVendor()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="vendormode" class="form-label">Mode<span class="mandatory">*</span>
                                        </label>
                                        <ng-select id="vendormode" placeholder="Select" formControlName="ddlVendorMode"
                                            [items]="vendorTypeList" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorForm.get('ddlVendorMode').touched) && vendorForm.get('ddlVendorMode').errors}" >
                                        </ng-select>

                                        <div *ngIf="(isFormSubmitted || vendorForm.get('ddlVendorMode').touched) && vendorForm.get('ddlVendorMode').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorForm.get('ddlVendorMode').errors.required">Vendor Mode is
                                                required</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="code" class="form-label">Code <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="code"
                                            formControlName="txtCode" >

                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="name" class="form-label">Name <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                            formControlName="txtName" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorForm.get('txtName').touched) && vendorForm.get('txtName').errors}" >
                                        <div *ngIf="(isFormSubmitted || vendorForm.get('txtName').touched) && vendorForm.get('txtName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorForm.get('txtName').errors.required">Name is
                                                required</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="contactperson" class="form-label">Contact Person </label>
                                        <input type="text" class="form-control form-control-sm" id="contactperson"
                                            formControlName="txtContactPerson" maxlength="50" >
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="emailid" class="form-label">Email ID </label>
                                        <input type="email" class="form-control form-control-sm" id="emailid"
                                            placeholder="Ex. abc@domain.com" formControlName="txtEmailId"
                                            maxlength="150"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorForm.get('txtEmailId').touched) && vendorForm.get('txtEmailId').errors}" >
                                        <div *ngIf="(isFormSubmitted || vendorForm.get('txtEmailId').touched) && vendorForm.get('txtEmailId').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorForm.get('txtEmailId').errors.pattern">Invalid email
                                                format</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="isactive" class="form-label">Status</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="isActive" >
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="">
                                        <label for="enabled" class="form-label">API Enabled</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" class="form-check-input" formControlName="apiEnabled" >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="fuelApplicable" class="form-label">Fuel Applicable</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="fuelApplicable" >
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="taxapplicable" class="form-label">Tax Applicable</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="taxApplicable" >
                                        </div>
                                    </div>
                                </div>

                                

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> Location Details </div>
                        <div class="card-body">
                            <app-location formGroupName="locationdetails" [formSubmitted]="isFormSubmitted"
                                [location]="locationDetails"></app-location>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm" >Update</button>
                        <a routerLink="/setup/vendors"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>


        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>